import CardContainer from 'Components/Common/CardContainer';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { calcMb } from 'Utils/File';
import GroupTextProps from 'Components/Page/Title/FormTextGroup';
import { formatPrice } from 'Utils/Numbers';
import { useAppSelector } from 'App/Store';
import { INCLUDE_COPY_RIGHT, LINK_JMD_TYPE_CONTENT, VIDEO_TYPES } from 'Constant/Title';
import MessageError from 'Components/Common/MessageError';
import { TitleApi } from 'Datasource/TitleApi';
import DropzoneDigitalSquare from '../Variation/DropzoneDigitalSquare';

interface DigitalVideoProps {
  data?: any;
  errors?: any;
  errorsForm?: any;
  riajGenreData?: any[];
  onClickError?: () => void;
}

export default function DigitalVideo(props: DigitalVideoProps): JSX.Element {
  const { data, errors = [], onClickError, riajGenreData, errorsForm } = props;
  const { videos } = data;
  const videosRef = useRef<any>([]);
  const { triggerMedia } = useAppSelector((state) => state.title);
  const [nameJpVideoJmd, setNameJpVideoJmd] = useState('');

  const detailVideoJmd = async (id: number) => {
    if (!id) return;
    const {
      data: { data },
    } = await TitleApi.getJmdVideoGenreById(id);
    setNameJpVideoJmd(data.nameJp);
  };

  useEffect(() => {
    detailVideoJmd(data.jmdVideoGenreId);
    return () => {
      setNameJpVideoJmd('');
    };
  }, [data]);

  const riajGenreNameJp = useCallback(
    (riajGenreId: number) => {
      return riajGenreData?.find((item) => item.value === riajGenreId)?.label ?? '';
    },
    [riajGenreData, data],
  );

  const convertAuthorizedType = (type: number, songDesc?: string) => {
    switch (type) {
      case 1:
        return 'JASRAC';
      case 2:
        return 'NexTone';
      case 3:
        return '自己管理';
      case 4:
        return songDesc ?? '';

      default:
        return '';
    }
  };

  const convertLyricsClassifyType = (type: number) => {
    switch (type) {
      case 1:
        return '１（原詞）';
      case 2:
        return '２（訳詞）';
      case 3:
        return '３（不明）';
      case 4:
        return ' ブランク（Vocalなし）';

      default:
        return '';
    }
  };

  const convertIvtType = (type: number) => {
    switch (type) {
      case 0:
        return 'I（Vocalなし）';
      case 1:
        return 'V（Vocalあり）';
      case 2:
        return 'T（詞のみ）';
      default:
        return '';
    }
  };

  const convertVersionIdentificationType = (type: number) => {
    switch (type) {
      case 0:
        return 'L（国内原版）';
      case 1:
        return 'I（外国原版）';
      default:
        return '';
    }
  };

  const convertLiveType = (type: number) => {
    switch (type) {
      case 0:
        return 'スタジオ';
      case 1:
        return 'ライブ';
      default:
        return '';
    }
  };

  useEffect(() => {
    if (triggerMedia === 'videos' && errors.length > 0) {
      const newListError = errors
        .map((item: any, index: number) => ({ ...item, index: index }))
        .filter((item: any) => !!item);
      videosRef?.current[newListError[0].index]?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'center',
      });
    }
  }, [errors, triggerMedia]);
  const convertCopyRightSong = (type: number) => {
    switch (type) {
      case INCLUDE_COPY_RIGHT.INCLUDE:
        return '著作権管理楽曲を含む';
      case INCLUDE_COPY_RIGHT.NOT_INCLUDE:
        return '含まない';
      default:
        return '';
    }
  };

  const convertVideoType = (type: number) => {
    switch (type) {
      case VIDEO_TYPES.MUSIC_VIDEO:
        return 'Music Video';
      case VIDEO_TYPES.OTHER:
        return 'Music Video以外（LIVEなど）';
      default:
        return '';
    }
  };

  return (
    <CardContainer title="動画コンテンツ" className="mb-3 mt-4 p-0">
      {videos.length === 0 &&
        (data?.id ? (
          <p>登録なし</p>
        ) : (
          <p className="d-flex align-items-center" style={{ color: '#ccc' }}>
            【登録されていません】
          </p>
        ))}
      {videos?.map((video: any, indexVideo: number) => {
        return (
          <div key={indexVideo} className="mb-4" ref={(el) => (videosRef.current[indexVideo] = el)}>
            <Row className="h-100" style={{ minHeight: '240px' }}>
              <Col md={4} className="mt-4">
                {video.urlPreview ? (
                  <video className="w-100" controls>
                    <track kind="captions" />
                    <source src={video?.urlPreview} type="video/mp4" />
                    Your browser does not support HTML video.
                  </video>
                ) : (
                  <div style={{ height: '100%', maxHeight: '202px' }}>
                    <DropzoneDigitalSquare
                      acceptTypes="video/mp4"
                      // eslint-disable-next-line @typescript-eslint/no-empty-function
                      handleChange={() => {}}
                      messageError={
                        !video?.url && errors[indexVideo]?.url?.message
                          ? errors[indexVideo]?.url?.message
                          : '未登録コンテンツあり'
                      }
                      onClickError={onClickError}
                      title="動画ファイルをアップロードしてください"
                      isDisable
                      maxHeight="250px"
                    />
                  </div>
                )}
              </Col>
              <Col md={8} className="mt-4">
                <Col md={12} className="mb-2">
                  <GroupTextProps
                    label="タイトル名:"
                    value={video?.name || ''}
                    errorContent={errors[indexVideo]?.name}
                    onClickError={onClickError}
                    mdLable={3}
                    mdValue={9}
                  />
                </Col>
                <Col md={12} className="mb-2">
                  {data?.jmdCooperation === LINK_JMD_TYPE_CONTENT.WORK_TOGETHER && (
                    <GroupTextProps
                      label="jmd動画ジャンル:"
                      value={nameJpVideoJmd}
                      errorContent={errorsForm?.jmdVideoGenreId}
                      onClickError={onClickError}
                      mdLable={3}
                      mdValue={9}
                    />
                  )}
                </Col>
                <Col md={12} className="mb-2">
                  <GroupTextProps
                    label="EC用宣伝文:"
                    value={video?.introEc || ''}
                    errorContent={errors[indexVideo]?.introEc}
                    onClickError={onClickError}
                    mdLable={3}
                    mdValue={9}
                  />
                  <GroupTextProps
                    label="著作権管理:"
                    value={
                      video?.includeCopyRightSong !== null
                        ? convertCopyRightSong(+video?.includeCopyRightSong)
                        : ''
                    }
                    errorContent={errors[indexVideo]?.includeCopyRightSong}
                    onClickError={onClickError}
                    mdLable={3}
                    mdValue={9}
                  />
                  <GroupTextProps
                    label="動画種別:"
                    value={video?.videoType !== null ? convertVideoType(+video?.videoType) : ''}
                    errorContent={errors[indexVideo]?.videoType}
                    onClickError={onClickError}
                    mdLable={3}
                    mdValue={9}
                  />
                  <GroupTextProps
                    label={'情報料:\n（みなし上代）'}
                    value={`${
                      video?.mediaInformationFee
                        ? `${formatPrice(video?.mediaInformationFee)}円(税抜)`
                        : '0円(税抜)'
                    }`}
                    errorContent={errors[indexVideo]?.mediaInformationFee}
                    onClickError={onClickError}
                    mdLable={3}
                    mdValue={9}
                    labelClass="text-prev-wrap"
                  />
                </Col>
                <Col md={7}>
                  <GroupTextProps label={`${calcMb(video?.size)}MB`} value={'  '} mdLable={8} />
                </Col>
              </Col>
            </Row>
            {video?.songs?.map((el: any, indexSong: number) => {
              return (
                <>
                  <hr />
                  <Row key={indexSong}>
                    <Col>
                      <GroupTextProps
                        mdLable={5}
                        label="曲名"
                        value={el?.name}
                        errorContent={errors[indexVideo]?.songs?.[indexSong]?.name}
                        onClickError={onClickError}
                      />
                      <GroupTextProps
                        mdLable={5}
                        label="曲名（フリガナ）"
                        value={el?.furiganaName}
                        errorContent={errors[indexVideo]?.songs?.[indexSong]?.furiganaName}
                        onClickError={onClickError}
                      />
                      <GroupTextProps
                        mdLable={5}
                        label="曲名（英語表記）"
                        value={el?.englishName}
                      />
                      {data?.jmdCooperation === LINK_JMD_TYPE_CONTENT.WORK_TOGETHER && (
                        <GroupTextProps
                          mdLable={5}
                          label="日本レコード協会ジャンル"
                          value={riajGenreNameJp(el?.riajGenreId)}
                          errorContent={errors[indexVideo]?.songs?.[indexSong]?.riajGenreId}
                          onClickError={onClickError}
                        />
                      )}
                      <GroupTextProps
                        mdLable={5}
                        label="IVT識別"
                        value={convertIvtType(el?.ivtType)}
                        errorContent={errors[indexVideo]?.songs?.[indexSong]?.ivtType}
                        onClickError={onClickError}
                      />
                      <GroupTextProps
                        mdLable={5}
                        label="作詞者名"
                        value={el?.musicianName}
                        errorContent={errors[indexVideo]?.songs?.[indexSong]?.musicianName}
                        onClickError={onClickError}
                      />
                      <GroupTextProps
                        mdLable={5}
                        label="作詞者名（フリガナ）"
                        value={el?.musicianFuriganaName}
                        errorContent={errors[indexVideo]?.songs?.[indexSong]?.musicianFuriganaName}
                        onClickError={onClickError}
                      />
                      <GroupTextProps
                        mdLable={5}
                        label="作詞者名（英語表記）"
                        value={el?.musicianEnglishName}
                        errorContent={errors[indexVideo]?.songs?.[indexSong]?.musicianEnglishName}
                        onClickError={onClickError}
                      />
                      <GroupTextProps
                        mdLable={5}
                        label="作曲者名"
                        value={el?.composerName}
                        errorContent={errors[indexVideo]?.songs?.[indexSong]?.composerName}
                        onClickError={onClickError}
                      />
                      <GroupTextProps
                        mdLable={5}
                        label="作曲者名（フリガナ）"
                        value={el?.composerFuriganaName}
                        errorContent={errors[indexVideo]?.songs?.[indexSong]?.composerFuriganaName}
                        onClickError={onClickError}
                      />
                      <GroupTextProps
                        mdLable={5}
                        label="作曲者名（英語表記）"
                        value={el?.composerEnglishName}
                        errorContent={errors[indexVideo]?.songs?.[indexSong]?.composerEnglishName}
                        onClickError={onClickError}
                      />
                      <GroupTextProps
                        mdLable={5}
                        label="編曲者名"
                        value={el?.arrangerName}
                        errorContent={errors[indexVideo]?.songs?.[indexSong]?.arrangerName}
                        onClickError={onClickError}
                      />
                      <GroupTextProps
                        mdLable={5}
                        label="編曲者名（フリガナ）"
                        value={el?.arrangerFuriganaName}
                        errorContent={errors[indexVideo]?.songs?.[indexSong]?.arrangerFuriganaName}
                        onClickError={onClickError}
                      />
                      <GroupTextProps
                        mdLable={5}
                        label="編曲者名（英語表記）"
                        value={el?.arrangerEnglishName}
                        errorContent={errors[indexVideo]?.songs?.[indexSong]?.arrangerEnglishName}
                        onClickError={onClickError}
                      />
                    </Col>
                    <Col>
                      <GroupTextProps
                        mdLable={5}
                        label="演奏時間"
                        value={el?.showTime}
                        errorContent={errors[indexVideo]?.songs?.[indexSong]?.showTime}
                        onClickError={onClickError}
                      />
                      <GroupTextProps
                        mdLable={5}
                        label="原盤識別"
                        value={convertVersionIdentificationType(el?.versionIdentificationType)}
                        errorContent={
                          errors[indexVideo]?.songs?.[indexSong]?.versionIdentificationType
                        }
                        onClickError={onClickError}
                      />

                      <GroupTextProps
                        mdLable={5}
                        label="ライブ区分"
                        value={convertLiveType(el?.liveType)}
                        errorContent={errors[indexVideo]?.songs?.[indexSong]?.liveType}
                        onClickError={onClickError}
                      />
                      <GroupTextProps
                        mdLable={5}
                        label="著作権信託先"
                        value={convertAuthorizedType(el?.authorizedGroupType, el?.authorizedGroup)}
                        errorContent={errors[indexVideo]?.songs?.[indexSong]?.authorizedGroupType}
                        onClickError={onClickError}
                      />
                      <GroupTextProps
                        mdLable={5}
                        label="ISRC番号"
                        value={el?.isrcCode}
                        errorContent={errors[indexVideo]?.songs?.[indexSong]?.isrcCode}
                        onClickError={onClickError}
                      />
                      <GroupTextProps
                        mdLable={5}
                        label="JASRAC作品コード"
                        value={el?.jasracCode}
                        errorContent={errors[indexVideo]?.songs?.[indexSong]?.jasracCode}
                        onClickError={onClickError}
                      />
                      <GroupTextProps
                        mdLable={5}
                        label="JASRAC以外の作品コード"
                        value={el?.otherJasracCode}
                        errorContent={errors[indexVideo]?.songs?.[indexSong]?.otherJasracCode}
                        onClickError={onClickError}
                      />
                      <GroupTextProps
                        mdLable={5}
                        label="情報料(みなし上代)"
                        value={`${
                          el?.informationFee
                            ? `${formatPrice(el?.informationFee)}円(税抜)`
                            : '0円(税抜)'
                        }`}
                        errorContent={errors[indexVideo]?.songs?.[indexSong]?.informationFee}
                        onClickError={onClickError}
                      />
                      <GroupTextProps
                        mdLable={5}
                        label="原詞訳詞区分"
                        value={convertLyricsClassifyType(el?.lyricsClassifyType)}
                        errorContent={errors[indexVideo]?.songs?.[indexSong]?.lyricsClassifyType}
                        onClickError={onClickError}
                      />
                    </Col>
                  </Row>
                </>
              );
            })}
            {!video?.songs?.length && errors[indexVideo]?.songs ? (
              <>
                <hr />
                <MessageError message={'著作権管理楽曲を登録してください'} />
              </>
            ) : (
              <></>
            )}
          </div>
        );
      })}
    </CardContainer>
  );
}
